<template>
  <div class="timeline">
    <div
      v-for="step in totalStep"
      :key="step"
      :class="{'current-step': currentStep === step}"
      :style="`width: calc(100% / ${totalStep})`"
      class="step"
    >
      <div
        :data-step="step"
        class="dot"
      />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TimelineComponent',
    props: {
      currentStep: {
        type: Number,
        default: null,
      },
      totalStep: {
        type: Number,
        default: null,
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import '~@/scss/media';

  .timeline {
    width: 100%;
    margin: 50px 0;
    position: relative;
    display: flex;

    &::after {
      content: '';
      height: 2px;
      position: absolute;
      left: 110px;
      right: 110px;
      top: calc(50% - 1px);
      z-index: -1;
      background-color: $light-grey;
    }

    .step {
      &.current-step {
        .dot {
          background-color: $primary;
        }
      }

      .dot {
        width: 30px;
        height: 30px;
        margin: auto;
        background-color: $grey;
        border-radius: 50%;
        position: relative;

        &::before {
          content: attr(data-step);
          position: absolute;
          color: $white;
          left: 0;
          right: 0;
          line-height: 30px;
          text-align: center;
          font-size: 14px;
        }
      }
    }
  }

  @include editable-max-width(765px) {
    .timeline {
      &::after {
        left: 0 !important;
        right: 0 !important;
      }
    }
  }

  @include editable-max-width(992px) {
    .timeline {
      &::after {
        left: 80px;
        right: 80px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Timeline.vue